import { AnalyticsPlatformName } from '@landr/core';
import { DeviceType } from '@landr/react-core';

export function getAnalyticsPlatformName(
    deviceType: DeviceType,
): AnalyticsPlatformName {
    if (deviceType === DeviceType.SamplesPlugin) {
        return AnalyticsPlatformName.Plugin;
    }

    if (deviceType === DeviceType.DesktopApp) {
        return AnalyticsPlatformName.Desktop;
    }

    return AnalyticsPlatformName.Web;
}
